ALLOWED_CONTROLLER = 'ids'
ALLOWED_ACTIONS = ['index']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)
  table = $('#id-verification-submittals').DataTable({
    iDisplayLength: 50,
    order: [ [ 6, "desc" ] ],
    aoColumnDefs: [ { 'bSortable': false, 'aTargets': [ 5 ] } ]
  })

$(document).ready(ready)
